import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

const Action = ({ block = {} }) => {
  const {
    heading = "Default Heading",
    text = "Default Text",
    btnLabel = "Click Here",
    conditionalLink = {},
    image = {},
  } = block;

  const { linkType, href, blank, internalLink } = conditionalLink || {};
  const { gatsbyImageData, altText } = image?.asset || {};

  return (
    <section className="section section--px">
      <div className="bg-orange-500 rounded-lg overflow-hidden">
        <div className="grid gap-5 lg:grid-cols-12 lg:items-center lg:justify-between w-full mx-auto z-20">
          <div className="lg:col-span-8 p-5">
            <h2 className="text-3xl lg:text-4xl font-extrabold text-orange-50 mb-2">
              {heading}
            </h2>
            <p className="font-normal lg:text-3xl text-orange-200">{text}</p>
            <div className="inline-block mt-10">
              {linkType === "external" && (
                <a
                  href={href || "#"}
                  target={blank ? "_blank" : ""}
                  rel={blank ? "noopener noreferrer" : ""}
                  className="btn-light"
                >
                  {btnLabel}
                </a>
              )}

              {linkType === "internal" && (
                <Link
                  to={internalLink?.slug?.current || "#"}
                  className="btn-light"
                >
                  {internalLink?.title || btnLabel}
                </Link>
              )}
            </div>
          </div>

          {gatsbyImageData && (
            <div className="lg:col-span-4 h-full">
              <GatsbyImage
                image={gatsbyImageData}
                alt={altText || ""}
                imgStyle={{ objectFit: "cover", width: "100%", height: "100%" }}
                loading="eager"
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Action;
